import { render, staticRenderFns } from "./compromiso.vue?vue&type=template&id=6facec96&scoped=true"
import script from "./compromiso.vue?vue&type=script&lang=js"
export * from "./compromiso.vue?vue&type=script&lang=js"
import style0 from "./compromiso.vue?vue&type=style&index=0&id=6facec96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6facec96",
  null
  
)

export default component.exports